<template>
  <div class="custom-table">
    <ve-table
      class="table"
      v-if="radioFlag"
      :scroll-width="scrollWidth"
      :max-height="maxHeight"
      :columns="columns"
      :fixed-header="true"
      :table-data="tableData"
      :border-around="true"
      :border-x="true"
      :border-y="true"
      inputmode="none"
      style="word-break: break-all; width: 100%"
      :event-custom-option="eventCustomOption"
      :row-key-field-name="rowKeyFieldName"
      :radio-option="radioOption"
      :checkbox-option="checkboxOption"
      @touchstart.native="handleTouchStart"
      @touchmove.native.prevent="handleTouchMove"
      @touchend.native="handleTouchEnd"
      :cellSelectionOption="cellSelectionOption"
    />
    <ve-table
      v-else
      class="table"
      :cellSelectionOption="cellSelectionOption"
      :scroll-width="scrollWidth"
      :max-height="maxHeight"
      :columns="columns"
      :fixed-header="true"
      :table-data="tableData"
      inputmode="none"
      :border-around="true"
      :border-x="true"
      :border-y="true"
      style="word-break: break-all; width: 100%"
      :event-custom-option="eventCustomOption"
      @touchstart.native="handleTouchStart"
      @touchmove.native.prevent="handleTouchMove"
      @touchend.native="handleTouchEnd"
    />
    <ve-pagination
      v-if="showPagination"
      class="pagination"
      :total="total"
      :page-index="index"
      inputmode="none"
      :page-size="size"
      :layout="['total', 'prev', 'next', 'sizer']"
      :paging-count="5"
      :page-size-option="pageSizeOption"
      popperAppendTo=".pagination"
      @on-page-number-change="pageNumberChange"
      @on-page-size-change="pageSizeChange"
    />
  </div>
</template>
<script>
import { throttle } from "lodash";

throttle;
export default {
  name: "CustomTable",
  props: {
    scrollWidth: { default: "100%", type: Number | String },
    maxHeight: { default: 500, type: Number | String },
    tableData: Array,
    columns: Array,
    showPagination: { type: Boolean, default: true },
    total: { default: 0, type: Number },
    pageSize: { default: 20, type: Number },
    pageIndex: { default: 1, type: Number },
    rowKeyFieldName: { default: "id", type: String },
  },
  data() {
    return {
      cellSelectionOption: {
        enable: false,
      },
      touchStartX: 0,
      touchStart: null,
      isDragging: false,
      startScrollLeft: 0,
      pageSizeOption: [5, 10, 20, 30, 40, 80, 100],
      radioOption: {
        selectedRowKey: "",
        selectedRowChange: ({ row }) => {
          this.changeSelectedRowKeyRadio(row);
          this.$emit("selectedRowChange", row);
        },
      },
      checkboxOption: {
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: (e) => {
          this.changeSelectedRowKeys(e);
          console.log(e, "行选择");
          this.$emit("selectedRowChange", e);
        },
        // 全选改变事件
        selectedAllChange: (e) => {
          this.changeSelectedRowKeys(e);
          this.$emit("selectedRowChange", e);
        },
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            click: (event) => {
              this.$emit("rowClick", { row, rowIndex, event });
            },
            // dblclick: (event) => {
            //
            //   this.$emit("rowClick",{row, rowIndex, event})
            // },
            // contextmenu: (event) => {
            //
            // },
            // mouseenter: (event) => {
            //
            // },
            // mouseleave: (event) => {
            //
            // },
          };
        },
      },
      layout: ["total", "prev", "pager", "next", "sizer"],
      index: 10,
      size: 1,
      radioFlag: false,
    };
  },

  watch: {
    pageIndex: {
      handler(newVal, oldVal) {
        this.index = newVal;
      },
      immediate: true,
    },
    pageSize: {
      handler(newVal, oldVal) {
        this.size = newVal;
      },
      immediate: true,
    },
    columns: {
      handler(newVal, oldVal) {
        this.radioFlag = newVal.some(
          (el) => el.type === "radio" || el.type === "checkbox"
        );
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  computed: {},
  mounted() {
    const container =
      this.$el &&
      this.$el.querySelector &&
      this.$el.querySelector(".ve-table-container");
    container.addEventListener("wheel", this.handleWheel, { passive: false });
  },
  beforeUnmount() {
    const container =
      this.$el &&
      this.$el.querySelector &&
      this.$el.querySelector(".ve-table-container");
    container.removeEventListener("wheel", this.handleWheel);
  },
  methods: {
    handleWheel(e) {
      const container =
        this.$el &&
        this.$el.querySelector &&
        this.$el.querySelector(".ve-table-container");
      const isVerticalScroll = e.deltaY !== 0;

      if (isVerticalScroll) {
        container.scrollTop += e.deltaY;
        e.preventDefault(); // 阻止页面滚动
      } else {
        container.scrollLeft += e.deltaX;
      }
    },
    handleTouchStart(e) {
      const container =
        this.$el &&
        this.$el.querySelector &&
        this.$el.querySelector(".ve-table-container");
      const touch = e.touches[0];

      this.touchStart = {
        x: touch.clientX,
        y: touch.clientY,
        scrollLeft: container.scrollLeft,
        scrollTop: container.scrollTop,
      };

      this.isDragging = true;
    },

    handleTouchMove: throttle(function (e) {
      if (!this.isDragging || !e.touches.length) return;

      const container =
        this.$el &&
        this.$el.querySelector &&
        this.$el.querySelector(".ve-table-container");
      const touch = e.touches[0];

      // 计算移动距离
      const deltaX = this.touchStart.x - touch.clientX;
      const deltaY = this.touchStart.y - touch.clientY;

      // 计算新滚动位置
      const newScrollLeft = this.touchStart.scrollLeft + deltaX;
      const newScrollTop = this.touchStart.scrollTop + deltaY;

      // 横向边界检查
      const maxScrollX = container.scrollWidth - container.clientWidth;
      container.scrollLeft = Math.max(0, Math.min(newScrollLeft, maxScrollX));

      // 纵向边界检查
      const maxScrollY = container.scrollHeight - container.clientHeight;
      container.scrollTop = Math.max(0, Math.min(newScrollTop, maxScrollY));

      // 根据移动方向阻止默认行为
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        e.preventDefault(); // 主要横向滚动时阻止默认
      }
    }, 16),

    handleTouchEnd() {
      this.isDragging = false;
      this.touchStart = null; //
    },
    unselectedAll() {
      this.checkboxOption.selectedRowKeys = [];
      this.radioOption.selectedRowKey = "";
    },
    changeSelectedRowKeyRadio(e) {
      this.radioOption.selectedRowKey = e.productId || e.id;
    },
    changeSelectedRowKeys(e) {
      this.checkboxOption.selectedRowKeys = e.selectedRowKeys;
    },
    pageNumberChange(val) {
      this.$emit("pageChange", { pageIndex: val, pageSize: this.size });
    },
    pageSizeChange(val) {
      this.$emit("pageChange", { pageIndex: this.index, pageSize: val });
    },
  },
};
</script>
<style lang="less" scoped>
.custom-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #efefef;
  z-index: auto !important;

  .table {
    flex: 1;
    overflow: auto;
    height: calc(100% - 40px); // 留出分页高度
  }

  .pagination {
    position: sticky;
    bottom: 0;
    height: 32px;
    background: #efefef; // 与表格背景一致
    z-index: 10;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05); // 添加顶部投影分隔
  }
}

::v-deep .ve-table-body-tr {
  height: 30px !important;

  td.ve-table-body-td {
    padding: 0 !important;
    height: 30px !important;
  }
}
.tr {
  height: 25px !important;
}

::v-deep .ve-table-container::-webkit-scrollbar {
  width: 8px; /* 横向滚动条 */
  height: 8px; /* 纵向滚动条 必写 */
}
::v-deep .ve-table-container::-webkit-scrollbar-thumb {
  background: #b8b8b8;
  border-radius: 3px;
  cursor: pointer; // 增加可拖动标识
  &:hover {
    background: #a0a0a0; // 悬停反馈
  }
}
::v-deep .ve-table-container {
  overflow-x: scroll !important;
  overscroll-behavior: contain; // 防止滚动传播
  touch-action: pan-x pan-y; // 明确触控方向
  transform: translateZ(0);
  will-change: scroll-position;
}
.ve-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

::v-deep .ve-pagination-pager {
  display: flex;
  flex-direction: row;
}
::v-deep .van-field__body {
  border-bottom: 1px solid #888;
}
::v-deep .ve-pagination {
  min-width: 360px; // 确保分页元素完整显示
  z-index: 10;
  button,
  .ve-pagination-item {
    padding: 0 8px;
    min-width: 28px;
  }
}
::v-deep .ve-table {
  height: 100% !important;
  .ve-table-container {
    height: 100% !important;
  }
}
</style>
